<template>
<div class="listItem" :class="{ 'active': active }">
  <div class="listItem-title">
    {{ title }}
  </div>
  <div class="listItem-subtitle">
    {{ subtitle }}
  </div>
  <i class="i listItem-star" v-if="starred">star</i>
</div>
</template>

<script>
export default {
  data(){ return {

  }},

  props: {
    title: String,
    subtitle: String,
    active: {
      default: false,
      type: Boolean
    },
    starred: {
      default: false,
      type: Boolean
    }
  },

  mounted(){

  }
}
</script>



// WEBPACK FOOTER //
// listitem.vue?6e081bf6